type HeadersInitLike = HeadersInit | Record<string, string>;

const ensureHeaders = (headers: unknown): HeadersInitLike => {
  return (headers as HeadersInitLike) ?? {};
};

/**
 * Wrapper around `fetch` for the admin app.
 * - Adds `ngrok-skip-browser-warning: 1` to avoid ngrok free-plan HTML splash pages.
 * - Adds `Authorization` from `admin_token` if not provided.
 */
export const adminFetch = async (input: RequestInfo | URL, init: RequestInit = {}) => {
  const token = localStorage.getItem('admin_token');

  const headers = new Headers(ensureHeaders(init.headers));

  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  headers.set('ngrok-skip-browser-warning', '1');

  return fetch(input, {
    ...init,
    headers,
  });
};

